import React from "react";
import { NextIsFree, NextIsPaid, NextIsReadOnly, NextIsTrialEnd, NotImplementedSubscription } from "../../../Subscription/Components/CommonPanelContent";

interface Props {
  activeSubscription: server.dto.Subscription
  nextSubscriptionType: server.dto.SubscriptionType
  nextBillingCycle: server.dto.BillingCycle
}

const TrailSubscription = (props: Props) => {
  switch (props.nextSubscriptionType.value) {
    case "free":
      return <NextIsFree {...props} />;
    case "paid":
      return <NextIsPaid {...props} />;
    case "readOnly":
      return <NextIsReadOnly {...props} />;
    case "cancelledByClient":
    case "cancelledBySystemOne":
    case "trialEnd":
      return <NextIsTrialEnd {...props} />;
    default:
      return <NotImplementedSubscription />;
  }
};

export default TrailSubscription;
